import { ZoningType } from '@popety-io/types'

/**
 * Get styling configuration for zoning layers based on type
 */
export function getZoningLayerStyle(
  zoningType: ZoningType,
  isSatellite: boolean
) {
  // Color scheme for each zoning type
  // general=green, cantonal=purple, local=red, partial=orange
  const colors: Record<ZoningType, { fill: string; outline: string }> = {
    general: {
      fill: isSatellite ? 'rgba(76, 175, 80, 0.4)' : 'rgba(76, 175, 80, 0.3)',
      outline: isSatellite
        ? 'rgba(76, 175, 80, 0.9)'
        : 'rgba(76, 175, 80, 0.8)',
    },
    cantonal: {
      fill: isSatellite ? 'rgba(156, 39, 176, 0.4)' : 'rgba(156, 39, 176, 0.3)',
      outline: isSatellite
        ? 'rgba(156, 39, 176, 0.9)'
        : 'rgba(156, 39, 176, 0.8)',
    },
    local: {
      fill: isSatellite ? 'rgba(244, 67, 54, 0.4)' : 'rgba(244, 67, 54, 0.3)',
      outline: isSatellite
        ? 'rgba(244, 67, 54, 0.9)'
        : 'rgba(244, 67, 54, 0.8)',
    },
    partial: {
      fill: isSatellite ? 'rgba(255, 152, 0, 0.4)' : 'rgba(255, 152, 0, 0.3)',
      outline: isSatellite
        ? 'rgba(255, 152, 0, 0.9)'
        : 'rgba(255, 152, 0, 0.8)',
    },
  }

  return colors[zoningType]
}

/**
 * Get source ID for a zoning type
 */
export function getZoningSourceId(type: ZoningType): string {
  return `zoning-${type}-source`
}

/**
 * Get layer ID for a zoning type
 */
export function getZoningLayerId(type: ZoningType): string {
  return `zoning-${type}-fill`
}

/**
 * Get outline layer ID for a zoning type
 */
export function getZoningOutlineLayerId(type: ZoningType): string {
  return `zoning-${type}-outline`
}

/**
 * All zoning types
 */
export const ZONING_TYPES: ZoningType[] = [
  'general',
  'cantonal',
  'local',
  'partial',
]

/**
 * Zoning type display names
 */
export const ZONING_TYPE_NAMES: Record<ZoningType, string> = {
  general: 'General',
  cantonal: 'Cantonal',
  local: 'Local',
  partial: 'Partial',
}
